import React from 'react'
import { Stack, Typography, useTheme, useMediaQuery } from '@mui/material'
import { useTranslation } from 'react-i18next'
import { gql, useQuery } from '@apollo/client'

import TemporaryIcon from 'components/global/TemporaryIcon'
import { useSites } from 'store'
import { TimeRange } from 'models'

import DevicesWidgetSkeleton from '../../Skeletons/DevicesWidgetSkeleton'
import WidgetContainer from './WidgetContainer'
import { useGetStatsTimeRange } from '../store'
import { convertDateRange } from '../hooks/use-traffic'

const OPERATION_TRAFFIC = gql`
  query TrafficAvgConnectedDevices($sfIds: [ID], $startsAt: String, $endsAt: String) {
    avg: trafficAvgConnectedDevices(sf_ids: $sfIds, starts_at: $startsAt, ends_at: $endsAt)
  }
`

const DevicesWidget = () => {
  const { t } = useTranslation()
  const theme = useTheme()
  const [{selected}] = useSites()
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'))
  const [globalRange] = useGetStatsTimeRange()
  const subtitlePeriod = globalRange === TimeRange.LastThirtyDays
    ? 'stats.traffic.widgets.devices.subtitle_day'
    : 'stats.traffic.widgets.devices.subtitle_month'
  const {data, loading} = useQuery(OPERATION_TRAFFIC, {
    variables: {
      sfIds: selected.map(({sf_id}) => sf_id),
      ...convertDateRange(globalRange)
    }
  })

  return (
    <WidgetContainer
      width={{ xs: '100%', sm: '50%', md: '15%' }}
      minHeight={isMobile ? '50px' : '80px'}
      loading={loading}
      LoadingComponent={DevicesWidgetSkeleton}
      isEmpty={!data || data.avg === 0}
      emptyIcon="laptop-mobile"
      emptyMessage={t('stats.traffic.widgets.devices.no_data')}
    >
      <Stack spacing={isMobile ? 0.5 : 1} alignItems="center">
        <Stack spacing={0.5} alignItems="center" pb={1}>
          <TemporaryIcon
            iconlabel="laptop-mobile"
            iconsize="16px"
            iconcolor="#1976d2"
          />
          <Typography
            sx={{
              fontWeight: 600,
              fontSize: isMobile ? '9px' : '12px',
              textTransform: 'uppercase',
              textAlign: 'center'
            }}
          >
            {t('stats.traffic.widgets.devices.title')}
          </Typography>
        </Stack>

        <Stack direction="row" spacing={1} alignItems="center" sx={{ height: isMobile ? '32px' : '40px' }}>
          <Typography
            sx={{
              fontSize: isMobile ? '24px' : '32px',
              fontWeight: 275,
              color: '#292929',
              lineHeight: 1
            }}
          >
            {Math.ceil(data?.avg || 0)}
          </Typography>
          <Stack
            direction="column"
            spacing={0.5}
            justifyContent="center"
            alignItems="flex-start"
            sx={{ height: '100%', justifyContent: 'center' }}
          >
            <Typography
              sx={{
                fontSize: isMobile ? '8px' : '12px',
                fontWeight: 400,
                color: 'text.secondary',
                lineHeight: 1,
                textAlign: 'left'
              }}
            >
              {t(subtitlePeriod)}
            </Typography>
            <Typography
              sx={{
                fontSize: isMobile ? '8px' : '12px',
                fontWeight: 400,
                color: 'text.secondary',
                lineHeight: 1,
                textAlign: 'left'
              }}
            >
              {t('stats.traffic.widgets.devices.subtitle_average')}
            </Typography>
          </Stack>
        </Stack>
      </Stack>
    </WidgetContainer>
  )
}

export default DevicesWidget